export default class Tabs {
    constructor($el) {
        this.$tabs = $el;
        this.$items = this.$tabs.querySelectorAll('[data-tab]');
        this.$activateButton = document.querySelectorAll('[data-activate-tab]');

        this.switchTab = this.switchTab.bind(this);
        this.activateTab = this.activateTab.bind(this);

        this.$items.forEach(item => item.addEventListener('click', this.switchTab));
        this.$activateButton.forEach(item => item.addEventListener('click', this.activateTab));
    }

    switchTab(e) {
        let target = e.target.closest('[data-tab]');
        let tab = this.$tabs.querySelector('#' + target.dataset.tab);
        if (tab.classList.contains('tab__item--active')) { return; }

        this.$items.forEach(item => {
            item.classList.remove('tab__item--active');
            this.$tabs.querySelector("#"+item.dataset.tab).classList.remove('tab__content--active');
        })

        target.classList.add('tab__item--active');
        tab.classList.add('tab__content--active');
    }

    activateTab(e) {
        console.log(e.target);
        const id = e.target.dataset.activateTab;

        this.$items.forEach(item => {
            item.classList.remove('tab__item--active');
            this.$tabs.querySelector("#"+item.dataset.tab).classList.remove('tab__content--active');
        })

        document.querySelector('[data-tab="'+id+'"]').classList.add('tab__item--active');
        document.querySelector('#'+id).classList.add('tab__content--active');
    }
}